import React, { useState } from 'react';
import './RecipeDetailPage.css';
import images from '../../assets/images';
import RecommendedRecipes from '../RecommendedRecipes';
import recipeData from '../../assets/recipes';
import ArrowIndicator from '../ArrowIndicator';

// Rating emotion icons
const ratingEmojis = {
  excellent: '😄',
  good: '🙂',
  okay: '😐',
  poor: '😞',
  veryPoor: '😢'
};

function RecipeDetailPage({ recipe, onBack, onSelectRecipe }) {
  const [ingredientsOpen, setIngredientsOpen] = useState(false);
  const [selectedRating, setSelectedRating] = useState(null);
  const [showRatingThanks, setShowRatingThanks] = useState(false);
  const [isFoodPandaHovered, setIsFoodPandaHovered] = useState(false);

  const handleRating = (rating) => {
    setSelectedRating(rating);
    setShowRatingThanks(true);
    setTimeout(() => setShowRatingThanks(false), 2000);

    if (typeof window.gtag === 'function') {
    window.gtag('event', 'recipe_rating', {
      'rating_label': rating, // This will be 'veryPoor', 'okay', etc.
      'page_location': window.location.href
    });
    
    }
    
  };

  const toggleIngredients = () => setIngredientsOpen((prev) => !prev);

  // Group ingredients by category for organized display
  const groupedIngredients = recipe.ingredients || [];

  // Recommended recipes excluding the current recipe
  const allRecipes = recipeData.recipes || recipeData;
  const recipeTitle = recipe.name || recipe.title;
  const recipeCookTime = recipe.cookTime || recipe.cookingTime;
  const recipeImage = recipe.imageUrl || recipe.imageLink;
  const recipeDescription = recipe.description || '';
  const cookingSteps = recipe.cookingSteps || [];
  const recommendedRecipes = allRecipes.filter((item) => (item.name || item.title) !== recipeTitle);

  // Handle recommended recipe click - load the new recipe detail
  const handleRecommendedRecipeSelect = (selectedRecipe) => {
    // Reset ingredients state for new recipe
    setIngredientsOpen(false);
    setSelectedRating(null);
    setShowRatingThanks(false);
    // Call the onSelectRecipe callback if provided, otherwise just reload with new recipe
    if (onSelectRecipe) {
      onSelectRecipe(selectedRecipe);
    }
  };

  return (
    <div>
    <div className="recipe-detail-page">
      {/* Two-Column Section: Image + Content */}
      <div className="recipe-detail-layout">
        {/* Left Column: Image */}
        <div className="image-column">
          <div className="detail-image-container">
            <img 
              src={recipeImage || images.christmasFood}
              alt={recipeTitle}
              className="detail-image"
            />
          </div>
        </div>

        {/* Right Column: Title, Info, Ingredients */}
        <div className="recipe-detail-content">
          <button className="back-button-detail" onClick={onBack}>
            ← Back
          </button>

          {/* Recipe Header */}
          <div className="recipe-detail-header">
            <h1 className="recipe-detail-title">{recipeTitle}</h1>
            {recipeDescription && (
              <p className="recipe-detail-description">{recipeDescription}</p>
            )}
          </div>

          {/* Recipe Info Card */}
          <div className="recipe-info-card">
            <div className="recipe-info-row">
              <span className="recipe-info-label">Cooking time:</span>
              <div className="recipe-info-value">
                <span>{recipeCookTime}</span>
              </div>
            </div>
            <div className="recipe-info-divider"></div>
            <div className="recipe-info-row">
              <span className="recipe-info-label">Difficulty:</span>
              <span className="recipe-info-value-text">{recipe.difficulty}</span>
            </div>
            <div className="recipe-info-divider"></div>
            <div className="recipe-info-row">
              <span className="recipe-info-label">Serving size:</span>
              <span className="recipe-info-value-text">{recipe.servings}</span>
            </div>
          </div>

          {/* Ingredients Section */}
          <div className="recipe-ingredients-section">
            <div className="ingredients-header">
              <h2 className="ingredients-title">Ingredients</h2>
              <button 
                className="ingredients-toggle" 
                type="button" 
                onClick={toggleIngredients} 
                aria-expanded={ingredientsOpen}
              >
                {ingredientsOpen ? '▲' : '▼'}
              </button>
            </div>
            {ingredientsOpen && (
              <>
                <div className="ingredients-list">
                  {groupedIngredients.map((category, categoryIndex) => (
                    <div key={categoryIndex}>
                      {category.category && (
                        <h3 className="ingredient-category-title">{category.category}</h3>
                      )}
                      {category.items && category.items.map((ingredient, index) => (
                        <div key={`${categoryIndex}-${index}`}>
                          <p className="ingredient-item">
                            {ingredient.name}
                            {ingredient.quantity && ` - ${ingredient.quantity}`}
                          </p>
                          {index < category.items.length - 1 && (
                            <div className="ingredient-divider"></div>
                          )}
                        </div>
                      ))}
                      {categoryIndex < groupedIngredients.length - 1 && (
                        <div className="ingredient-divider" style={{ margin: '20px 0' }}></div>
                      )}
                    </div>
                  ))}
                </div>
                <div className="ingredients-divider-main"></div>
                <div className="buy-ingredients-section">
                  <h3 className="buy-ingredients-title">Buy ingredients online</h3>
                  <div className="buy-online-logos">
                    <a href="https://www.daraz.pk" target="_blank" rel="noopener noreferrer" className="logo-circle" title="Daraz" aria-label='Daraz Store'>
                      <img src={images.darazlogo} alt="Daraz Logo" className="daraz-logo" />
                    </a>
                    <a href="https://www.foodpanda.pk/darkstore/r1vf/pandamart-bahadurabad-khi/campaign/banner-699d7ff86d77c07e85fa4ddb?utm_campaign=coop_coop_web_dma_aut_aa_FP_PK_Knorr&utm_medium=coops" target="_blank" rel="noopener noreferrer" className="logo-circle" title="Food Panda" aria-label='Food Panda Store'>
                      <img
                        src={isFoodPandaHovered ? images.foodPandaLogoHovered : images.foodPandaLogo}
                        alt="Food Panda Logo"
                        className="foodpanda-logo"
                        onMouseEnter={() => setIsFoodPandaHovered(true)}
                        onMouseLeave={() => setIsFoodPandaHovered(false)}
                      />
                    </a>
                    {/* <a href="https://www.naheed.pk" target="_blank" rel="noopener noreferrer" className="logo-circle" title="Naheed">
                      🛒
                    </a>
                    <a href="https://www.alfatah.pk" target="_blank" rel="noopener noreferrer" className="logo-circle" title="Al-Fatah">
                      🛒
                    </a>
                    <a href="https://www.carrefour.com" target="_blank" rel="noopener noreferrer" className="logo-circle" title="Carrefour">
                      🛒
                    </a> */}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Full Width Section: Instructions */}
      <div className="lets-cook-section">
        <h2 className="lets-cook-title">Let's get cooking</h2>
        {cookingSteps.length > 0 ? (
          <div className="cooking-steps-container">
            {cookingSteps.map((stepGroup, groupIndex) => (
              <div key={groupIndex} className="cooking-step-group">
                <h3 className="cooking-step-heading">{stepGroup.step}</h3>
                <ul className="cooking-step-instructions">
                  {stepGroup.instructions.map((instruction, instrIndex) => (
                    <li key={instrIndex} className="cooking-step-instruction">
                      {instruction}
                    </li>
                  ))}
                </ul>
                {groupIndex < cookingSteps.length - 1 && (
                  <div className="cooking-step-divider"></div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <ol className="lets-cook-list">
            {recipe.instructions && recipe.instructions.map((step, index) => (
              <li key={index} className="lets-cook-step">
                {step}
              </li>
            ))}
          </ol>
        )}
      </div>


      {/* Full Width Section: Rating */}
      <div className="rate-experience-section">
        <h3 className="rate-experience-title">Liked this recipe? Tell us what you think!</h3>
        <div className="rating-options-row">
          <button
            className={`rating-button ${selectedRating === 'veryPoor' ? 'active' : ''}`}
            onClick={() => handleRating('veryPoor')}
            type="button"
            title="Very poor"
          >
            <div className={`rating-circle ${selectedRating === 'veryPoor' ? 'active' : ''}`}>
              😢
            </div>
            <span className="rating-label">Not<br/>Vibing</span>
          </button>
          <button
            className={`rating-button ${selectedRating === 'poor' ? 'active' : ''}`}
            onClick={() => handleRating('poor')}
            type="button"
            title="Poor"
          >
            <div className={`rating-circle ${selectedRating === 'poor' ? 'active' : ''}`}>
              😞
            </div>
            <span className="rating-label">Still<br/>Confused</span>
          </button>
          <button
            className={`rating-button ${selectedRating === 'okay' ? 'active' : ''}`}
            onClick={() => handleRating('okay')}
            type="button"
            title="Okay"
          >
            <div className={`rating-circle ${selectedRating === 'okay' ? 'active' : ''}`}>
              😐
            </div>
            <span className="rating-label">Meh,<br/>IDK</span>
          </button>
          <button
            className={`rating-button ${selectedRating === 'good' ? 'active' : ''}`}
            onClick={() => handleRating('good')}
            type="button"
            title="Good"
          >
            <div className={`rating-circle ${selectedRating === 'good' ? 'active' : ''}`}>
              🙂
            </div>
            <span className="rating-label">Refresh-<br/>Ready</span>
          </button>
          <button
            className={`rating-button ${selectedRating === 'excellent' ? 'active' : ''}`}
            onClick={() => handleRating('excellent')}
            type="button"
            title="Excellent"
          >
            <div className={`rating-circle ${selectedRating === 'excellent' ? 'active' : ''}`}>
              😄
            </div>
            <span className="rating-label">Chef<br/>Vibes</span>
          </button>
        </div>
        {showRatingThanks && (
          <p className="rating-thanks">Thanks for rating us!</p>
        )}
      </div>
    </div>
    <ArrowIndicator />
      {/* Recommended Recipes */}
      <RecommendedRecipes
        recipes={recommendedRecipes}
        onSelectRecipe={handleRecommendedRecipeSelect}
      />
    </div>
  );
}

export default RecipeDetailPage;